import React, { useState, useEffect, useCallback } from "react";
import styled, { keyframes } from "styled-components";
import useWindowDimensions from "../../utils/breakpoints";
import breakpoint from "styled-components-breakpoint";
import { global } from "../../constants";

/** Sticky Footer CTA
 *  This is a footer Call to Action.
 *  It will have a "Buy Now" button stickied to the bottom of the page when it passes the Y coordinate parsed as
 * startY, and disappear after the endY.
 * */
const fadeIn = keyframes`
  from {
    transform: scale(1);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    transform: scale(1);
    opacity: 1;
  }

  to {
    transform: scale(1);
    opacity: 0;
  }
`;

const StyledDiv = styled.div`
  position: fixed;
  background: #fff;
  display: flex;
  bottom: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${(props) => (props.autoHeight ? "auto" : "50px")};
  padding ${(props) => (props.fullWidth ? "0" : "2rem")};
  box-shadow: 0px 2px 6px 2px rgb(0, 0, 0, 0.15);

  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  animation: ${(props) => (props.visible ? fadeIn : fadeOut)} 1s linear;
  transition: visibility 1s linear;

  ${breakpoint("md")`
    height: 100px;
  `};
`;

export const StickyFooterCTA = ({ startYRef, endYRef, children, fullWidth, autoHeight }) => {
  const [currentPosY, setCurrentPosY] = useState(0);
  // we handle the viewport height here to ensure we're accounting for hte scroll being
  // from the top, but for the bottom component we need to take away this height.
  const { height: screenHeight } = useWindowDimensions();

  const [startRefOffsetPosY, setStartRefOffsetPosY] = useState();
  const [endRefOffsetPosY, setEndRefOffsetPosY] = useState();

  // useEffect for the startY & endY
  useEffect(() => {
    if (startYRef.current != undefined) {
      setStartRefOffsetPosY(startYRef.current.offsetTop + startYRef.current.offsetHeight);
    }
    if (endYRef.current != undefined) {
      setEndRefOffsetPosY(endYRef?.current?.offsetTop + endYRef?.current?.offsetHeight);
    }
  }, [startYRef, endYRef]);

  // This listens for the "scroll" event. Will update the currentY to properly display the item.
  useEffect(() => {
    const onScroll = (e) => {
      setCurrentPosY(e.target.documentElement.scrollTop + global.HEADER_OFFSET); // this offset is starting to be a glorious pain.
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [currentPosY]);
  return (
    <StyledDiv
      visible={
        currentPosY > startRefOffsetPosY && currentPosY < endRefOffsetPosY - screenHeight
          ? true
          : false
      }
      tabIndex={-1}
      fullWidth={fullWidth}
      autoHeight={autoHeight}
    >
      {children}
    </StyledDiv>
  );
};

StickyFooterCTA.propTypes = {};
